import React from 'react'
import { FilterSection, FilterButton as StyledFilterButton, FilterContainer, FilterPopup } from './styles'

const FilterButtonComponent = ({ icon, children, onClick, isOpen, popupContent }) => {
  return (
    <FilterSection>
      <FilterContainer>
        <StyledFilterButton onClick={onClick}>
          {icon}
          {children}
        </StyledFilterButton>
        {isOpen && (
          <FilterPopup>
            {popupContent}
          </FilterPopup>
        )}
      </FilterContainer>
    </FilterSection>
  )
}

export default FilterButtonComponent
